import styled from 'styled-components'

import Header from '../../components/Header'
import { mq, pxToRem, sizes } from '../../theme'
import Footer from '../../components/Footer'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
  width: 100%;
  min-height: 100vh;
  overflow: clip; // not "hidden" to prevent sticky from not working but careful, there was hidden here for a reason possibly
  /* & * {
    outline: 1px solid red;
  } */
  @supports (min-height: 100svh) {
    min-height: 100svh;
  }
`
export const _Header = styled(Header)``
export const Content = styled.main`
  flex: 1 1 auto;
  position: relative;
  z-index: ${({ theme }) => theme.zIndexes.default};
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  padding-block-end: ${pxToRem(80)};
  & > *:only-child {
    flex: 1;
  }
  @media ${mq(sizes.desktop)} {
    padding-block-end: ${pxToRem(200)};
  }
`
export const _Footer = styled(Footer)``
export const Modals = styled.div``
